import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './SessionDetail.css';

function SessionDetail() {
  const { sessionId } = useParams();
  const [answers, setAnswers] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [editStates, setEditStates] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const aRes = await axios.get(`https://api.discovery.quantecsystems.com/answers/${sessionId}`);
      const qRes = await axios.get('https://api.discovery.quantecsystems.com/questions');
      setAnswers(aRes.data);
      setQuestions(qRes.data);
    };
    fetchData();
  }, [sessionId]);

  const getQuestionData = (questionId) => questions.find(q => q.questionId === questionId);

  const handleEditToggle = (idx) => {
    setEditStates(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  const handleAnswerChange = (idx, value) => {
    const updated = [...answers];
    updated[idx].answer = value;
    setAnswers(updated);
  };

  const handleMultiSelectChange = (idx, option) => {
    const current = answers[idx].answer || [];
    const updated = current.includes(option)
      ? current.filter(o => o !== option)
      : [...current, option];
    handleAnswerChange(idx, updated);
  };

  const handleDynamicListChange = (idx, index, value) => {
    const current = Array.isArray(answers[idx].answer) ? [...answers[idx].answer] : [];
    current[index] = value;
    handleAnswerChange(idx, current);
  };

  const handleDynamicListAdd = (idx) => {
    const current = Array.isArray(answers[idx].answer) ? [...answers[idx].answer] : [];
    current.push('');
    handleAnswerChange(idx, current);
  };

  const handleDynamicListRemove = (idx, index) => {
    const current = Array.isArray(answers[idx].answer) ? [...answers[idx].answer] : [];
    current.splice(index, 1);
    handleAnswerChange(idx, current);
  };

  const handleSave = async (idx) => {
  const answer = answers[idx];
  const cleanedId = answer.answerId.split(":")[0]; // Just the UUID

  try {
    await axios.put(`https://api.discovery.quantecsystems.com/answers/${cleanedId}`, {
      answer: answer.answer,
    });
    setEditStates(prev => ({ ...prev, [idx]: false }));
  } catch (error) {
    console.error("Save failed:", error);
    alert("Failed to save answer.");
  }
};



  return (
    <div className="session-detail-container">
      <h2>Session Details: {sessionId}</h2>
      <ul className="answer-list">
        {answers.map((a, idx) => {
          const q = getQuestionData(a.questionId);
          if (!q) return null;

          const isEditing = editStates[idx];
          const options = q.options || q.meta?.options || [];
          const value = a.answer;

          return (
            <li key={idx} className="answer-item">
              <strong>{q.prompt}:</strong>
              {isEditing ? (
                <div className="edit-block">
                  {q.type === 'text' || q.type === 'number_input' ? (
                    <input
                      type={q.type === 'number_input' ? 'number' : 'text'}
                      value={value || ''}
                      onChange={e => handleAnswerChange(idx, e.target.value)}
                    />
                  ) : q.type === 'yesno' ? (
                    <select
                      value={value || ''}
                      onChange={e => handleAnswerChange(idx, e.target.value)}
                    >
                      <option value="">Select...</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  ) : q.type === 'radio' || q.type === 'select' ? (
                    <select
                      value={value || ''}
                      onChange={e => handleAnswerChange(idx, e.target.value)}
                    >
                      <option value="">Select...</option>
                      {options.map((opt, i) => (
                        <option key={i} value={opt}>{opt}</option>
                      ))}
                    </select>
                  ) : q.type === 'multi' ? (
                    <div className="multi-options">
                      {options.map((opt, i) => (
                        <label key={i}>
                          <input
                            type="checkbox"
                            checked={(value || []).includes(opt)}
                            onChange={() => handleMultiSelectChange(idx, opt)}
                          />
                          {opt}
                        </label>
                      ))}
                    </div>
                  ) : q.type === 'dynamic_list' ? (
                    <div className="dynamic-list">
                      {(value || []).map((val, i) => (
                        <div key={i} className="dynamic-row">
                          <input
                            type="text"
                            value={val}
                            onChange={e => handleDynamicListChange(idx, i, e.target.value)}
                          />
                          <button onClick={() => handleDynamicListRemove(idx, i)}>X</button>
                        </div>
                      ))}
                      <button onClick={() => handleDynamicListAdd(idx)}>+ Add Another</button>
                    </div>
                  ) : (
                    <em>Unsupported question type</em>
                  )}
                  <button onClick={() => handleSave(idx)}>Save</button>
                </div>
              ) : (
                <>
                  <span>
                    {Array.isArray(value) ? value.join(', ') : value}
                  </span>
                  <button onClick={() => handleEditToggle(idx)}>Edit</button>
                </>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default SessionDetail;
